interface Props {
  color?: string;
  clipId?: string;
}

function FileAdd(props: Props) {
  const { color = "white", clipId = "152768" } = props;

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath={`url(#clip0_7528_${clipId})`}>
        <path
          className="icon-svg"
          d="M19.8574 19.8572C19.8574 20.2361 19.7068 20.5995 19.4389 20.8674C19.171 21.1353 18.8077 21.2858 18.4288 21.2858H5.57164C5.19276 21.2858 4.82939 21.1353 4.56149 20.8674C4.29358 20.5995 4.14307 20.2361 4.14307 19.8572V4.14293C4.14307 3.76405 4.29358 3.40068 4.56149 3.13277C4.82939 2.86487 5.19276 2.71436 5.57164 2.71436H12.7145L19.8574 9.85721V19.8572Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="icon-svg"
          d="M11.2856 10.2144V15.2144M8.78564 12.7144H13.7856"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={`url(#clip0_7528_${clipId})`}>
          <rect width="20" height="20" fill="white" transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FileAdd;
